import { create } from 'zustand';

interface ServiceStatusState {
  isServiceUnavailable: boolean;
  isOffline: boolean;
  setServiceUnavailable: (value: boolean) => void;
  setOffline: (value: boolean) => void;
}

export const useServiceStatusStore = create<ServiceStatusState>((set) => ({
  isServiceUnavailable: false,
  isOffline: typeof navigator !== 'undefined' ? !navigator.onLine : false,
  setServiceUnavailable: (value: boolean) => set({ isServiceUnavailable: value }),
  setOffline: (value: boolean) => set({ isOffline: value }),
}));
